// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../AppData/Roaming/nvm/v16.20.2/node_modules/expo-cli/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "", ""]);
// Exports
module.exports = exports;
